import React, { createContext, useState, useEffect } from 'react';
import { cognitoService } from '../services/cognitoService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const currentUser = await cognitoService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error('Error loading user:', error);
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, []);

  const signIn = async (username, password) => {
    try {
      await cognitoService.signIn(username, password);
      const currentUser = await cognitoService.getCurrentUser();
      setUser(currentUser);
    } catch (error) {
      console.error('Error signing in:', error);
      throw error; // rethrow error so the calling component can handle it
    }
  };

  const signOut = () => {
    cognitoService.signOut();
    setUser(null);
  };

  const value = {
    user,
    setUser, // <-- Include setUser in the context value
    loading,
    signIn,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
